module.exports = __webpack_public_path__ + "img/chart.47a39b3.png";